import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/types/RootState';

type ClaimSetsSlice = RootState['claimSets'];

const selectClaimSetsSlice = (state: RootState) => state.claimSets;

export const selectClaimSetNormalizedV2Response = createSelector(
  selectClaimSetsSlice,
  (state: ClaimSetsSlice) => state.normalizedV2Response,
);

export const selectCurrentClaimSetId = createSelector(
  selectClaimSetsSlice,
  (state: ClaimSetsSlice) => state.currentClaimSetId,
);

export const selectCurrentClaimSetNumber = createSelector(
  selectClaimSetsSlice,
  (state: ClaimSetsSlice) => state.currentClaimSetNumber,
);

export const selectClaimSetRequestsStates = createSelector(
  selectClaimSetsSlice,
  (state: ClaimSetsSlice) => state.dataRequestsStates,
);

export const selectIsOverviewDetailsExpanded = createSelector(
  selectClaimSetsSlice,
  (state: ClaimSetsSlice) => state.isOverviewDetailsExpanded,
);

export const selectClaimSetInsured = createSelector(
  selectClaimSetsSlice,
  (state: ClaimSetsSlice) => state.normalizedV2Response?.entities?.Insured,
);
